import axios, { AxiosResponse } from 'helper/axios-facade';
import appConfig from 'helper/mapBackendConfig';
import { GetProgramDayForDayNumberType } from 'types/services/spring/GetProgramDayForDayNumber';
import { GetProgramDayForTodayType } from 'types/services/spring/GetProgramDayForToday';

export const fetchActiveProgramDayToday = (programId: string): Promise<AxiosResponse<GetProgramDayForTodayType>> => {
	const requestURL = `${appConfig.env.urlSpringAPI}/programdays/${programId}/today`;
	return axios.get(requestURL);
};

export const fetchProgramDay = (
	programId: string,
	dayNumber: number
): Promise<AxiosResponse<GetProgramDayForDayNumberType>> => {
	const requestURL = `${appConfig.env.urlSpringAPI}/programdays/${programId}/${dayNumber}`;
	return axios.get(requestURL);
};

export const fetchCalendar = (activeProgramId: string): Promise<AxiosResponse<Object>> => {
	const requestURL = `${appConfig.env.urlSpringAPI}/programdays/${activeProgramId}/calendar`;
	return axios.get(requestURL);
};

export const fetchCalendarToday = (activeProgramId: string): Promise<AxiosResponse<Object>> => {
	const requestURL = `${appConfig.env.urlSpringAPI}/programdays/${activeProgramId}/calendar/today`;
	return axios.get(requestURL);
};

export const fetchCalendarProgramDayTodos = (
	activeProgramId: string,
	dayNumber: number,
	offset: number
): Promise<AxiosResponse<Object>> => {
	const requestURL = `${appConfig.env.urlSpringAPI}/programdays/${activeProgramId}/calendar/${dayNumber}/${offset}`;
	return axios.get(requestURL);
};
